<template>
    <div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/live/theme/create')"
                type="primary"
                icon="el-icon-plus"
                @click="$router.push('/live/theme/add')"
                size="small"
                >新增主题</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="主题名称" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.title" placement="top">
                            <span class="ellipsis" >{{ scope.row.title }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="serialNum" label="序号" width="120"></el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" size="mini" type="success">正常</el-tag>
                        <el-tag v-else size="mini" type="info">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/live/theme/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <template v-if="$utils.have('/live/theme/updateStatus')">
                            <el-button
                                v-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                icon="el-icon-remove-outline"
                                @click="editStatus(scope.row.id,0)"
                                >隐藏</el-button
                            >
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                icon="el-icon-circle-check"
                                @click="editStatus(scope.row.id,1)"
                                >显示</el-button
                            >
                        </template>
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-document-copy"
                            @click="copy(scope.row.id)"
                            >复制链接</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <input class="copyTool" ref="copyTool" :value="copyValue" />
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            listLoading: true,
            copyValue:''
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/live/theme/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //新增事件
        add() {
            this.$router.push({ path: "/live/theme/add" });
        },
        //编辑事件
        edit(id) {
            this.$router.push({
                path: `/live/theme/edit/${id}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //复制链接
        copy(id){
            this.copyValue = `${process.env.VUE_APP_SSWAP_URL}/pages/live/theme/theme?id=${id}`;
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
         //改变状态
        editStatus(id,status){
            const _msg = status === 0 ? '确定要隐藏吗?' : '确定要显示吗?';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/live/theme/updateStatus',
                    method: 'POST',
                    params: {id:id,status:status}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
}
</style>